
export class Warning {

  constructor(
    public code?: string,
    public values?: any,
  ) {
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/warning.ts